import React from 'react'
import { Grid, Paper, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, Tooltip, Typography } from '@material-ui/core';
import { EmptyCollection } from '../../../shared_elements';
import { Link } from 'react-router';

const PrimaryLlpList = ({ primaryLlpInfo }) => {
    return (
        <>
        <Paper>
            <Table className='mui-table-format' stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell><div >Module</div></TableCell>
                        <TableCell><div >Description</div></TableCell>
                        <TableCell><div >Part Number</div></TableCell>
                        <TableCell><div >Limit Type</div></TableCell>
                        <TableCell><div >Limit</div></TableCell>
                        <TableCell><div >Escalation %</div></TableCell>
                        <TableCell><div >Replacemet Cost ($)</div></TableCell>
                        <TableCell><div >Year of Cost</div></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody >
                    {primaryLlpInfo?.primary_llp?.map((data, index) =>
                        <TableRow key={index} style={{ verticalAlign: 'text-bottom' }}>
                            <TableCell style={{ alignContent: 'center' }}><div >{data?.module?.name || '--'}</div></TableCell>
                            <TableCell style={{ alignContent: 'center' }}><div >{data?.description?.name || '--'}</div></TableCell>
                            <TableCell style={{ alignContent: 'center' }}><Link to={`/config-data/engineLlpsConfig/llpPart/View/${data?.id}`}> <Tooltip title="On Clicking on this it will redirect to particular llp part detail"><div style={{textDecoration:"underline"}} >{data?.part_number || '--'}</div></Tooltip></Link></TableCell>
                            {data?.linked_engine?.map((item, index) =>
                                <>
                                    <TableCell style={{ alignContent: 'center' }}><div >{data?.is_hour_cycle === 'CY' ? 'Cycle' : 'Hour' || '--' }</div></TableCell>
                                    <TableCell style={{ alignContent: 'center' }}><div >{ item?.limit || '--'}</div></TableCell>
                                    <TableCell style={{ alignContent: 'center' }}><div >{ item?.escalation_percentage || '--'}</div></TableCell>
                                    <TableCell style={{ alignContent: 'center' }}><div >{item?.cost || '--'}</div></TableCell>
                                    <TableCell style={{ alignContent: 'center' }}><div >{item?.year_of_cost || '--'}</div></TableCell>
                                </>)}
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper>
        <Paper>
            {!primaryLlpInfo?.primary_llp?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No Linked LLP Found' /></div> : null }
        </Paper>
        </>
    )
}

export default PrimaryLlpList